import { BACKEND_APIS, USER_ROLES, WEBBACK_V2_API } from "@constants"
import { useUserApp } from "@hooks"

const V2_STOCK = `${WEBBACK_V2_API}/stock-assortment`
const V2_PRICING = `${WEBBACK_V2_API}/pricing`

// **The url no longer depends on the role.** v1 has a twin nested per role (`changes-retailer`,
// `changes-seller`) with duplicated logic; v2 has one endpoint and the back decides what the price
// is compared against from the user's role — the RRSP for a brand, their own main site for a
// retailer. So there is nothing left to branch on here, and sending a role to a `-retailer` or
// `-seller` url on v2 would 404: those endpoints do not exist.
//
// Reasoning: dipi-webback-v2/plans/869e5pfw2--rrsp-and-retailers.md §5.1 (one module, one API) and
// §0.6 (the four behaviour differences v1's retailer nested actually had, and what was decided for
// each). The role is still returned below, because the *columns* do vary: the table relabels the
// price column and the Excel switches between `RRSP` and `My Price`.

export default function useStockChangesRoleConfig() {
	const { userRole, userUseRRSP } = useUserApp()

	return {
		urlApi: `${V2_STOCK}/changes/context`,
		urlApiExcel: `${V2_STOCK}/changes/excel`,
		urlApiPriceEvolution: `${V2_PRICING}/changes/price-stock-evolution`,
		isMarketplacesUser: userRole === USER_ROLES.MARKETPLACES,
		isRetailerUser: userRole === USER_ROLES.RETAILER,
		userUseRRSP: userUseRRSP
	}
}
